import React, { useEffect, useState } from "react";
import { useSideModalScrollToTop, useSideModalScrollListener, useUtils, useFormattedMessage } from "hooks";

// import Cookies from "js-cookie";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
    selectBankAccount,
    selectUserSelectedBankAccount,
    selectPrimaryBankAccount,
    selectUserDetails,
    selectUserMangopay,
    selectPayInWalletBalance,
    selectBlockedWalletBalance,
    selectStatusMangopay,
    selectIsEnrollSCARequired,
    selectIsSetupEwallet,
} from "store/user/account/selectors";

import { redirectToMangopaySCA, sideModalScrollHidden } from "utils";

import ArrowRight from "assets/images/svg/arrow-right.svg";

import Close from "components/Close";
import WalletOverview from "./WalletOverview";
import TransferEMoney from "./transferEMoney";
import TransferEMoneyConfirmation from "./transferEMoney/Confirmation";
import TransferEMoneyOverview from "./transferEMoney/Overview";
import PayOut from "./payOut";
import PayOutOverview from "./payOut/Overview";
import PayInInfo from "./payIn/Info";
import PayInOverview from "./payIn/Overview";
import AllActivities from "./allActivities";
import ActivityDetails from "./activityDetails";
import AllBankAccount from "./payOut/AllBankAccount";
import AddBankAccount from "./payOut/AddBankAccount";
import ReserveOrders from "./reserveOrders";
import RetakeIF from "./retakeIF";
import SetupEwallet from "./SetupEwallet";
import EwalletSuccess from "./EwalletSuccess";
import MangopayScaVerification from "components/MangopayScaVerification";

const FINX_COOKIE = require("common/constants");
import Cookies from "js-cookie";
import { checkMangoPayBalance, paymentCreateRecipient, paymentEnrollSCA } from "api";
import { sendFormError } from "i18n/messages/errors";
import { WALLET_TYPE } from "constants/index";
import { fetchBlockedWalletBalanceStart, fetchPayInWalletBalanceSuccess } from "store/user/account/actions";
import NewLoader from "components/NewLoader";

const EuroWalletSideModal = (props) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    const {
        open,
        onCloseButtonClick,
        initiateClose,
        userMangopayDetails,
        payInWalletBalance,
        blockedWalletBalance,
        userDetails,
        selectedBankAccount,
        primaryBankAccount,
        bankAccounts,
        statusMangopay,
        statusSecondaryMarket,
        isEnrollSCARequired,
        isSetupEwallet,
        fetchPayInWalletBalanceSuccess,
        fetchBlockedWalletBalanceStart,
    } = props;

    const cameraPermissionEnabled = Cookies.get(FINX_COOKIE.CAMERA_PERMISSION_ENABLED) || "true";

    const [backSlideEffect, setBackSlideEffect] = useState("");

    const isMangopayScaRequired = isEnrollSCARequired;

    const [step, setStep] = useState(
        isMangopayScaRequired ? "mangopayScaVerification" : isSetupEwallet?.required ? "setupEwallet" : "walletOverview",
    );
    const [closeTitle, setCloseTitle] = useState("E-Wallet");
    const [stepData, setStepData] = useState({});
    const [data, updateData] = useState({});
    const [isMangopayScaButtonLoading, setMangopayScaButtonLoading] = useState(false);
    const [requestError, setRequestError] = useState(false);
    const [redirectUrlToFetchWalletBalance, setRedirectUrlToFetchWalletBalance] = useState(null);
    const [isFetchingBalance, setFetchingBalance] = useState(false);

    const isApp = useUtils().isPlatformSourceFromApp;
    useSideModalScrollListener(props, isApp);

    useEffect(() => {
        isApp && sideModalScrollHidden(open);
    }, [open]);

    useEffect(() => {
        open && !isEnrollSCARequired && !isSetupEwallet?.required && setFetchingBalance(true);

        () => setFetchingBalance(false);
    }, [open, isEnrollSCARequired]);

    useEffect(() => {
        if (!open || isEnrollSCARequired || isSetupEwallet?.required) return;

        try {
            checkMangoPayBalance(WALLET_TYPE.PAY_IN_WALLET)
                .then((res) => {
                    setFetchingBalance(false);
                    if (res?.data?.data?.checkMangoPayBalance?.redirectURL) {
                        setRedirectUrlToFetchWalletBalance(res.data.data.checkMangoPayBalance.redirectURL);
                        setStep("mangopayScaVerification");
                    } else if (res?.data?.data?.checkMangoPayBalance) {
                        fetchPayInWalletBalanceSuccess(res.data.data.checkMangoPayBalance);
                        fetchBlockedWalletBalanceStart({ type: WALLET_TYPE.BLOCKED_WALLET });
                    }
                })
                .catch(() => {
                    setRedirectUrlToFetchWalletBalance(null);
                    setFetchingBalance(false);
                });
        } catch (error) {
            setRedirectUrlToFetchWalletBalance(null);
            setFetchingBalance(false);
        }
    }, [open, isEnrollSCARequired]);

    // 1. Wallet Balances
    useEffect(() => {
        updateData((prev) => ({
            ...prev,
            payInWalletBalance: payInWalletBalance ?? 0,
            blockedWalletBalance: blockedWalletBalance ?? 0,
        }));
    }, [payInWalletBalance, blockedWalletBalance]);

    // 2. User Info
    useEffect(() => {
        const { FirstName: firstName, LastName: lastName, Email: email } = userDetails || {};

        updateData((prev) => ({
            ...prev,
            currentUser: { firstName, lastName, email },
        }));
    }, [userDetails]);

    // 3. Selected Bank Account
    useEffect(() => {
        updateData((prev) => ({
            ...prev,
            selectedBankAccount: { ...(selectedBankAccount || {}) },
        }));
    }, [selectedBankAccount]);

    // 4. Primary Bank Account
    useEffect(() => {
        updateData((prev) => ({
            ...prev,
            bankAccount: { ...(primaryBankAccount || {}) },
        }));
    }, [primaryBankAccount]);

    // 5. All Bank Accounts
    useEffect(() => {
        updateData((prev) => ({
            ...prev,
            allBankAccounts: bankAccounts || [],
        }));
    }, [bankAccounts]);

    // 6. Mangopay Details
    useEffect(() => {
        updateData((prev) => ({
            ...prev,
            mangopay: { ...(userMangopayDetails || {}) },
        }));
    }, [userMangopayDetails]);

    useEffect(() => {
        if (initiateClose) {
            reset();
        }
    }, [initiateClose]);

    const onClose = () => {
        onCloseButtonClick();
        reset();
    };

    const reset = () => {
        setStep(isMangopayScaRequired ? "mangopayScaVerification" : isSetupEwallet?.required ? "setupEwallet" : "walletOverview");
        setStepData({});
        setRequestError("");
    };

    const setStepAndData = (step, nextStepData) => {
        setStep(step);
        setStepData({
            [step]: nextStepData,
        });
    };

    const renderStep = {
        setupEwallet: (
            <SetupEwallet
                open={open}
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setStep={setStep}
                apiCall={isSetupEwallet?.apiCall}
            />
        ),
        ewalletSuccess: (
            <EwalletSuccess backSlideEffect={backSlideEffect} setBackSlideEffect={setBackSlideEffect} setStep={setStep} />
        ),
        mangopayScaVerification: (
            <MangopayScaVerification
                backSlideEffect={backSlideEffect}
                isLoading={isMangopayScaButtonLoading}
                requestError={requestError}
                onButtonClick={() => {
                    try {
                        const returnURL = isApp ? "/account#accountEwallet" : "/dashboard#accountEwallet";
                        if (isMangopayScaRequired) {
                            setMangopayScaButtonLoading(true);
                            paymentEnrollSCA()
                                .then((res) => {
                                    setMangopayScaButtonLoading(false);
                                    if (!res || res.errors || res.data.errors || res.data.data.errors) {
                                        return setRequestError(formatMessage(sendFormError));
                                    }

                                    if (res?.data?.data?.paymentEnrollSCA?.redirectURL) {
                                        const redirectURL = res.data.data.paymentEnrollSCA.redirectURL;
                                        redirectToMangopaySCA(redirectURL, returnURL, isApp);
                                    }
                                })
                                .catch(() => {
                                    setMangopayScaButtonLoading(false);
                                });
                        } else if (
                            stepData?.mangopayScaVerification?.action === "verifyBankAccount" &&
                            stepData?.mangopayScaVerification?.bankAccountUID
                        ) {
                            setMangopayScaButtonLoading(true);
                            paymentCreateRecipient({ bankAccountUID: stepData.mangopayScaVerification.bankAccountUID })
                                .then((res) => {
                                    setMangopayScaButtonLoading(false);
                                    if (!res || res.errors || res.data.errors || res.data.data.errors) {
                                        return setRequestError(formatMessage(sendFormError));
                                    }

                                    if (res?.data?.data?.paymentCreateRecipient?.redirectURL) {
                                        const redirectURL = res.data.data.paymentCreateRecipient.redirectURL;
                                        redirectToMangopaySCA(redirectURL, returnURL, isApp);
                                    }
                                })
                                .catch(() => {
                                    setMangopayScaButtonLoading(false);
                                });
                        } else {
                            redirectToMangopaySCA(redirectUrlToFetchWalletBalance, returnURL, isApp);
                        }
                    } catch (error) {
                        setMangopayScaButtonLoading(false);
                    }
                }}
            />
        ),
        walletOverview: (
            <WalletOverview
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                statusMangopay={statusMangopay}
                statusSecondaryMarket={statusSecondaryMarket}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
                setStepAndData={setStepAndData}
            />
        ),
        transferEMoney: (
            <TransferEMoney
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                setStepAndData={setStepAndData}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
            />
        ),
        transferEMoneyConfirmation: (
            <TransferEMoneyConfirmation
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                stepData={stepData.transferEMoneyConfirmation}
                setStepAndData={setStepAndData}
                data={data}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
            />
        ),
        transferEMoneyOverview: (
            <TransferEMoneyOverview
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                stepData={stepData.transferEMoneyOverview}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
            />
        ),
        payOut: (
            <PayOut
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStepAndData={setStepAndData}
                setStep={setStep}
                stepData={stepData}
                setStepData={setStepData}
            />
        ),
        payOutOverview: (
            <PayOutOverview
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                stepData={stepData.payOutOverview}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
            />
        ),
        payInInfo: (
            <PayInInfo
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
            />
        ),
        payInOverview: (
            <PayInOverview
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                stepData={stepData.payInOverview}
                data={data}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
            />
        ),
        allActivities: (
            <AllActivities
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setShowDate={() => {}}
                setStep={setStep}
                setCloseTitle={setCloseTitle}
                setStepAndData={setStepAndData}
            />
        ),
        activityDetails: (
            <ActivityDetails
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setStep={setStep}
                stepData={stepData}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
            />
        ),
        allBankAccount: (
            <AllBankAccount
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStepAndData={setStepAndData}
                setStep={setStep}
                stepData={stepData}
                updateData={updateData}
                setStepData={setStepData}
            />
        ),
        addBankAccount: (
            <AddBankAccount
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                data={data}
                setShowDate={() => {}}
                setCloseTitle={setCloseTitle}
                setStepAndData={setStepAndData}
                setStep={setStep}
                updateData={updateData}
                setStepData={setStepData}
            />
        ),
        reserveOrders: (
            <ReserveOrders
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setShowDate={() => {}}
                stepData={stepData.reserveOrders}
                setStepAndData={setStepAndData}
                data={data}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
            />
        ),
        retakeIF: (
            <RetakeIF
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setShowDate={() => {}}
                data={data}
                setCloseTitle={setCloseTitle}
                setStep={setStep}
                setStepAndData={setStepAndData}
                stepData={stepData.retakeIF}
                onCloseButtonClick={onClose}
                isCameraPermissionEnabled={cameraPermissionEnabled === "true"}
            />
        ),
    };

    return (
        <>
            <div className={`euro-wallet-side-modal side-modal editable-modal shadow${open ? " opened" : " closed"}`}>
                <div className={"close-container d-flex align-center justify-between"}>
                    <div className="d-flex">
                        {(step === "mangopayScaVerification" || step === "walletOverview") && (
                            <div className="back-arrow-top">
                                <span
                                    className="back-arrow"
                                    onClick={() => {
                                        if (step === "mangopayScaVerification" && stepData?.mangopayScaVerification?.comingFrom) {
                                            setStep(stepData?.mangopayScaVerification?.comingFrom);
                                            setStepData((prev) => ({
                                                ...prev,
                                                mangopayScaVerification: {},
                                            }));
                                            setBackSlideEffect("step-slide-right");
                                        } else {
                                            props.onBackButtonClick();
                                        }
                                    }}
                                >
                                    <ArrowRight />
                                </span>
                            </div>
                        )}
                        <h4 className="modal-title my-0">{closeTitle}</h4>
                    </div>
                    <div className="d-flex align-center">
                        <Close className="close-button fw-600" onCloseButtonClick={onClose} />
                    </div>
                </div>
                <div className="side-modal-wrap flex px-0">
                    <div className="modal-body">
                        <div className="side-modal-container mw-100 pt-0">
                            {isFetchingBalance ? (
                                <NewLoader type="primary" className="editable-modal-loader" />
                            ) : (
                                renderStep[step]
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    userMangopayDetails: selectUserMangopay,
    payInWalletBalance: selectPayInWalletBalance,
    blockedWalletBalance: selectBlockedWalletBalance,
    userDetails: selectUserDetails,
    selectedBankAccount: selectUserSelectedBankAccount,
    primaryBankAccount: selectPrimaryBankAccount,
    bankAccounts: selectBankAccount,
    statusMangopay: selectStatusMangopay,
    isEnrollSCARequired: selectIsEnrollSCARequired,
    isSetupEwallet: selectIsSetupEwallet,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPayInWalletBalanceSuccess: (value) => dispatch(fetchPayInWalletBalanceSuccess(value)),
    fetchBlockedWalletBalanceStart: (value) => dispatch(fetchBlockedWalletBalanceStart(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EuroWalletSideModal);
